<template>
  <div class="mod-dial cm-modal" @click="$emit('close')">
    <div class="mod-cont" @click.stop>
      <span class="close-main" @click="$emit('close')"><i class="bi bi-x-lg"></i></span>

      <div class="mod-body cm-prompt">
        <h3 class="tab-title">{{ $t('CM_IMG_PROMPT_TITLE') }}</h3>
        <p class="cm-prompt-hint">{{ $t('CM_IMG_PROMPT_HINT') }}</p>

        <!-- та самая картинка: видно, что именно разбираем -->
        <div class="cm-prompt-image" v-if="imageUrl && !previewBroken">
          <img :src="imageUrl" alt="" @error="previewBroken = true" />
        </div>

        <div v-if="error" class="cm-prompt-error">{{ error }}</div>

        <textarea
          v-model="text"
          class="cm-prompt-area"
          :maxlength="maxLen"
          spellcheck="false"
          :placeholder="$t('CM_IMG_PROMPT_TITLE')"
        ></textarea>

        <div class="cm-prompt-foot">
          <span class="cm-prompt-count">
            {{ text.length }} / {{ maxLen }}
            <template v-if="isCustom"> · {{ $t('CM_IMG_PROMPT_CUSTOM') }}</template>
          </span>
          <button class="btn-st-tr" :disabled="!isCustom" @click="reset">
            {{ $t('CM_IMG_PROMPT_RESET') }}
          </button>
          <button class="btn-st-red" :disabled="!text.trim() || loading" @click="run">
            {{ loading ? $t('CM_IMG_LOADING') : $t('CM_IMG_PROMPT_RUN') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Запрос к модели перед разбором картинки — чтобы подбирать формулировки и
 * сразу видеть результат. Правленый текст лежит в localStorage браузера
 * (см. api/controllers/content-monitoring), стандартный приходит с сервера.
 */
import {
  fetchImagePrompt,
  readImagePrompt,
  saveImagePrompt,
} from "@/api/controllers/content-monitoring";

export default {
  name: "Cm-image-prompt",
  props: {
    // идёт ли сейчас разбор — кнопку блокируем, модалку не закрываем
    loading: { type: Boolean, default: false },
    // ссылка на разбираемую картинку; у видео без обложки её нет — тогда
    // превью просто не показываем
    imageUrl: { type: String, default: "" },
  },
  data() {
    return {
      text: readImagePrompt(),
      defaultText: "",
      maxLen: 8000,
      error: "",
      previewBroken: false,
    };
  },
  computed: {
    isCustom() {
      return !!this.defaultText && this.text.trim() !== this.defaultText.trim();
    },
  },
  watch: {
    text(value) {
      // сохраняем на каждый ввод: правку не должно терять ни закрытие модалки,
      // ни перезагрузка страницы
      saveImagePrompt(this.defaultText && value.trim() === this.defaultText.trim() ? "" : value);
    },
  },
  created() {
    fetchImagePrompt()
      .then((d) => {
        this.defaultText = d.prompt || "";
        this.maxLen = d.max_len || this.maxLen;
        if (!this.text) this.text = this.defaultText;
      })
      .catch((e) => {
        this.error = e.message;
      });
  },
  methods: {
    reset() {
      this.text = this.defaultText;
    },
    run() {
      this.$emit("run", this.text.trim());
    },
  },
};
</script>

